// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MxWe","right":"styles_right__3mgGX"};